import { Link, type LinkProps } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';

type LocalizedLinkProps = Omit<LinkProps, 'to'> & {
  to: string;
};

export default function LocalizedLink({ to, ...props }: LocalizedLinkProps) {
  const { localizedPath } = useLanguage();
  return <Link to={localizedPath(to)} {...props} />;
}
